import React from 'react'

export default function Header({children, className}) {
  return (
      <h3 className={className}>{children}</h3>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/Header.js